export default [
  {
    name: 'worker-jobs',
    path: '/worker-jobs',
    component: () => import('@/app-modulo/comuns/worker-jobs/WorkerJobs.vue'),
    meta: {
      resource: 'propostar',
      action: 'read',
      pageTitle: 'Worker Jobs',
      breadcrumb: [],
    },
  },
]
